/* eslint-disable */
import intl from 'react-intl-universal'
import Cookies from 'js-cookie'

import { notificationSend } from '../../util/notify'
import { hasPermission } from '../services/permission'
import { setIsOnline, setIsSignedOut, isSignedOut } from '~/redux/appReducer'
import CONSTANTS from '~/constants'
import {
  MIN_IDLE_TIMEOUT,
  MIN_IDLE_WARNING,
} from '~/modules/settings/controller'
import { getFeatures } from '../../featureFlags'

export default [
  '$http',
  '$q',
  '$timeout',
  'toastr',
  '$rootScope',
  '$window',
  '$ngRedux',
  padlock,
]
const TOOK_OVER_USER_NAME = 'ellipsis__take-over-user-name'
const FORCE_TAKEOVER_AFTER_TIMEOUT_MS = 10000

const getGlobalTimeout = () => {
  // TODO: remove this after Trident integration will be ready.
  if (CONSTANTS.NODE_ENV === 'testing') {
    return Date.now() + 1
  }

  const sessionInfo = Cookies.getJSON('Arc-Client-Info') || {}
  const globalTimeout = sessionInfo['global-exp']
  return globalTimeout
}

function padlock($http, $q, $timeout, toastr, $rootScope, $window, $ngRedux) {
  const rootScopeOnce = (event, callbackFn) => {
    const unsubscribe = $rootScope.$on(event, (...args) => {
      unsubscribe()
      callbackFn(...args)
    })
  }

  function reportOnline(isOnline) {
    $ngRedux.dispatch(setIsOnline(isOnline))
  }

  function checkStoryHasBeenTookOver() {
    const tookOverBy = window.sessionStorage.getItem(TOOK_OVER_USER_NAME)
    if (tookOverBy) {
      window.sessionStorage.removeItem(TOOK_OVER_USER_NAME)
      $timeout(() => {
        toastr.error(
          intl.get('padlock.checkStoryHasBeenTookOver.error', {
            tookOverBy: tookOverBy,
          }),
          {
            timeOut: 0,
            extendedTimeout: 0,
          }
        )
      }, 2000)
    }
  }

  rootScopeOnce('ELLIPSIS_STORY_LOADED', checkStoryHasBeenTookOver)

  /* Call locking service and get the locks for the passed in ids */
  /* Used on the search page to update the lock status */
  this.getLocksForIds = (ids) => {
    const req = {
      method: 'POST',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/getLocksForIds/`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({ items: ids }),
    }
    return $http(req)
  }

  let hasLock = false
  let _lastLock

  this.obtainLock = (id, subId) => {
    const deferred = $q.defer()
    const storyAuth = window.userRolesAuth.story
    const isReadOnly =
      hasPermission(storyAuth.viewStory) && !hasPermission(storyAuth.editStory)

    const lockId = id + (subId ? '-' + subId : '')
    if (_lastLock && lockId !== _lastLock) {
      this.cleanUp()
    }
    _lastLock = lockId
    const req = {
      method: 'POST',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/lock/` + lockId,
      timeout: 5000,
    }
    $http(req).then(
      (response) => {
        deferred.resolve({
          isMyLock: true,
          readonly: isReadOnly,
        })
        this.updateTimeout()
        maintainLock(req, lockId)
      },
      ({ data = [] }) => {
        let lockDetails = {
          isMyLock: false,
          readonly: isReadOnly,
        }
        data.forEach((lock) => {
          if (lock.item_id === lockId) {
            lockDetails.lockedBy = lock.user_name
          }
        })
        deferred.reject(lockDetails)
      }
    )

    return deferred.promise
  }

  this.hasLock = (id, subId) => {
    return hasLock
  }

  let activeKnocks = []

  // Keep knock toast handles
  let knockToasts = []

  function checkKnocks(items, lockId) {
    const lock = items.find((lock) => lock.item_id === lockId)
    const knocks = lock ? lock.knocks : []

    if (
      activeKnocks.length !== knocks.length ||
      JSON.stringify(activeKnocks.map((i) => i.user_id)) !==
        JSON.stringify(knocks.map((i) => i.user_id))
    ) {
      onActiveKnocks(knocks, lockId)
    }
    activeKnocks = knocks
  }

  const acceptKnock = (userId, userName, lockId) => {
    this.cancelLock()
    hasLock = false
    const req = {
      method: 'POST',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/relinquish/` + lockId,
      data: { user_id: userId, user_name: userName },
    }
    return $http(req)
  }

  const denyKnock = (userId, lockId) => {
    const req = {
      method: 'POST',
      url:
        `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/denyknock/` +
        lockId +
        '/' +
        encodeURIComponent(userId),
    }
    return $http(req)
  }

  const knockToast = (knock, lockId) => {
    let html = `
      <div class="bg-danger p-3">
        <div class="p-3 text-white toast-container" style="width: 90%">
          <i class="fa fa-2x fa-exclamation-circle text-white"></i>
          &nbsp;
          <div class="d-inline-block align-middle mx-2">
            <i>${
              knock.user_name || intl.get('padlock.knockToast.unknownUser')
            }</i>${intl.get('padlock.knockToast.request')}
          </div>
          <button class="btn btn-outline-info mx-2">
            <a href="javascript:void(0)" onclick="this.dataset.clicked=1">${intl.get(
              'padlock.knockToast.pass'
            )}</a>
          </button>
          <button class="btn btn-info">
            <a href="javascript:void(0)">${intl.get(
              'padlock.knockToast.deny.button'
            )}</a>
          </button>
        </div>
      </div>
    `
    const handlers = {
      accept: () => {
        toastr.clear()
        $('.feature-focused [contenteditablebind]').trigger('blur')
        $timeout(function () {
          $rootScope.$broadcast('SAVE_STORY')
        }, 0)
        rootScopeOnce('SAVE_SUCCESS', () => {
          acceptKnock(knock.user_id, knock.user_name, lockId).then(
            () => {
              $timeout(() => $window.location.reload(), 3000)
            },
            (...args) => {
              toastr.error(intl.get('padlock.knockToast.accept.error'))
              console.error(
                'There was a problem allowing the user to take over story.',
                args
              )
            }
          )
        })
      },
      deny: () => {
        toastr.clear()
        denyKnock(knock.user_id, lockId).then(
          () => {
            toastr.info(intl.get('padlock.knockToast.deny.success'))
          },
          (...args) => {
            toastr.error(intl.get('padlock.knockToast.deny.error'))
            console.error('Knock error', args)
          }
        )
      },
    }
    return toastr.info(html, {
      toastClass: 'el-toast',
      iconClass: 'el-toast-knock-request',
      allowHtml: true,
      timeOut: 0,
      extendedTimeOut: 0,
      tapToDismiss: false,
      closeButton: true,
      closeHtml: '<div/>',
      onTap: ({ el }) => {
        const clickedLink = $('a[data-clicked]', el)
        if (clickedLink.length === 0) {
          handlers.deny()
        } else {
          handlers.accept()
        }
      },
    })
  }

  const onActiveKnocks = (knocks, lockId) => {
    if (!knocks.length) {
      knockToasts.forEach(toastr.clear)
      knockToasts = []
      return
    }
    const forceKnock = knocks.find((knock) => knock.force_knock)
    if (forceKnock) {
      $window.sessionStorage.setItem(TOOK_OVER_USER_NAME, forceKnock.user_name)

      toastr.error(
        intl.get('padlock.onActiveKnocks.error', {
          username: forceKnock.user_name,
        }),
        {
          timeOut: 0,
          extendedTimeout: 0,
        }
      )
      rootScopeOnce('SAVE_SUCCESS', () => {
        acceptKnock(forceKnock.user_id, forceKnock.user_name, lockId).then(
          () => {
            $timeout(() => $window.location.reload(), 500)
          }
        )
      })

      $('.feature-focused [contenteditablebind]').trigger('blur')
      $timeout(function () {
        $rootScope.$broadcast('SAVE_STORY')
      }, 0)

      return
    }

    knockToasts = knocks.map((knock) => knockToast(knock, lockId))
    const recentKnocks = knocks.filter((ck) =>
      activeKnocks.every((ak) => ak.user_id !== ck.user_id)
    )
    if (recentKnocks.length) {
      const names = recentKnocks.map((k) => k.user_name).join(' and ')
      notificationSend(
        intl.get('padlock.onActiveKnocks.request', { name: names })
      )
    }
  }

  this.getActiveKnocks = () => {
    return activeKnocks
  }

  let maintainLockPromise
  let maintainLockTimeout
  let noLockCount = 0
  let openedToastNoLock
  let lastLockTS

  function notifySignedOut(signedOut) {
    // Dispatch signed out action only if state changes
    if (isSignedOut($ngRedux.getState()) !== signedOut) {
      $ngRedux.dispatch(setIsSignedOut(signedOut))
    }
  }

  function hasExpiredOktaCookie(signedOut) {
    const globalTimeout = getGlobalTimeout()

    if (!globalTimeout) {
      // No cookie case
      return true
    }

    // Check if cookie expired
    return globalTimeout <= Date.now()
  }

  function maintainLock(req, lockId) {
    if (hasExpiredOktaCookie()) {
      // If expired/no cookie, go nothing but keep calling maintainLock
      // after signing in with Okta cookie should be back
      // When it back, normal lock check mechanism should kick in
      // User either might still have a lock, reacquire it or
      // be kicked out since someone else got that lock
      maintainLockTimeout = $timeout(() => maintainLock(req, lockId), 2500)
      notifySignedOut(true)
      return
    } else {
      notifySignedOut(false)
    }

    maintainLockPromise = $q.deferred
    req.timeout = maintainLockPromise

    const inactiveTimeCheck = activeTimeout
      ? activeTimeout - new Date()
      : Number.POSITIVE_INFINITY
    const warningTimeCheck = warningTimeout
      ? warningTimeout - new Date()
      : Number.POSITIVE_INFINITY

    // tryng to detect if user had story open, computer wet to sleep, wakes up, and timer restarts as if locked.
    if (lastLockTS && new Date() - lastLockTS > 60000) {
      toastr.warning(intl.get('padlock.maintainLock.inactive.warning'), {
        timeOut: 60000,
      })
      // todo, fetch story and see if the parent revision changed?
    }
    lastLockTS = new Date()

    if (inactiveTimeCheck < 0) {
      if (document.activeElement) {
        angular.element(document.activeElement).change()
      }
      document.body.focus()
      // TODO Eric: Switch to Common modal
      $('#sessionExpiredModal').modal('show')
      rootScopeOnce('SAVE_SUCCESS', cleanUp)
      $rootScope.$broadcast('SAVE_STORY')
      $rootScope.$broadcast('LOCK_STORY_INACTIVE_TIMEOUT')
      return
    } else if (warningTimeCheck < 0) {
      const toastContainer = document.getElementById('toast-container')
      if (!toastContainer || toastContainer.childElementCount < 1) {
        toastr.warning(intl.get('padlock.maintainLock.inactive.expire'))
      }
    }

    $http(req).then(
      (response) => {
        hasLock = true
        checkKnocks(response.data, lockId)
        maintainLockPromise = null
        maintainLockTimeout = $timeout(() => maintainLock(req, lockId), 5000)
        if (noLockCount > 0) {
          noLockCount = 0
          reportOnline(true)
        }
        if (openedToastNoLock) {
          toastr.clear(openedToastNoLock)
          openedToastNoLock = null
        }
      },
      (response) => {
        // ignore when the Ajax call was aborted from navigation
        if (response.xhrStatus === 'abort') {
          return
        }

        if (response.data && response.data[0] && response.data[0].user_name) {
          var userName = response.data[0].user_name || 'an unknown user'

          $window.sessionStorage.setItem(TOOK_OVER_USER_NAME, userName)
          $window.location.reload()
        } else {
          // Allowing one bad connection before informing the user.
          noLockCount++
          // Display toast after 20 seconds and each 60 seconds after that
          if (noLockCount === 8 || noLockCount % 24 === 0) {
            reportOnline(false)
            openedToastNoLock = toastr.warning(
              intl.get('padlock.maintainLock.lostlock'),
              {
                timeOut: '20000',
                extendedTimeout: '20000',
              }
            )
          }
          maintainLockTimeout = $timeout(() => maintainLock(req, lockId), 2500)
        }

        hasLock = false
        maintainLockPromise = null
      }
    )
  }

  // Called by knock (with force) after FORCE_TAKEOVER_AFTER_TIMEOUT_MS timeout
  const forceTakeover = (lockId) => {
    const req = {
      method: 'POST',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/force/` + lockId,
    }
    return $http(req)
  }

  this.cancelLock = () => {
    if (maintainLockPromise) {
      maintainLockPromise.reject()
    }
    if (maintainLockTimeout) {
      $timeout.cancel(maintainLockTimeout)
      maintainLockTimeout = null
    }
  }

  let activeKnockPromise
  let activeKnockTimeout
  let forceKnockTimeout

  function executeKnock(req, lockId, force, resolve, reject) {
    activeKnockPromise = $q.deferred
    req.timeout = activeKnockPromise

    // Start force timeout when force knock initiated
    if (force && !forceKnockTimeout) {
      forceKnockTimeout = $timeout(
        () => forceTakeover(lockId),
        FORCE_TAKEOVER_AFTER_TIMEOUT_MS
      )
    }
    $http(req).then(
      (response) => {
        getFeatures().then((features) => {
          if (!features.isEnabled('draftApiStateful')) {
            const lockData = response.data
            activeKnockPromise = null
            if (lockData[0].isNowMine) {
              if (forceKnockTimeout) {
                $timeout.cancel(forceKnockTimeout)
                forceKnockTimeout = null
              }
              resolve(lockData)
            } else {
              // Stuck the user id on the request for easy lookup
              const me = lockData[0].me

              // Loop through the knock requests and see if user's knock was rejected
              const isDenied = lockData.some((item) => {
                if (item.item_id === lockId) {
                  return item.knocks.some((knock) => {
                    return me === knock.user_id && knock.ignored_on
                  })
                }
                return false
              })

              if (isDenied) {
                // owner denied the knock request
                reject(lockData)
              } else {
                // user did not respond to request so lets try again
                activeKnockTimeout = $timeout(
                  () => executeKnock(req, lockId, force, resolve, reject),
                  2000
                )
              }
            }
          } else {
            const username = window.localStorage.getItem('arc.username')
            const locks = response.data?.locks
            /**
             * draftApiStateful
             * Wait until user_id is the same from the username
             */
            if (locks && locks[0].user_id === username) {
              resolve(locks[0])
            } else {
              const newReq = {
                method: 'GET',
                url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v2/lock?document_id=${lockId}`,
              }
              activeKnockTimeout = $timeout(
                () => executeKnock(newReq, lockId, force, resolve, reject),
                2000
              )
            }
          }
        })
      },
      (response) => {
        activeKnockPromise = null
        console.error('Bad knock response', response)
        reject()
      }
    )
  }

  this.knock = (id, url = '', subId, force) => {
    const deferred = $q.defer()
    const lockId = id + (subId ? '-' + subId : '')
    const req = {
      method: 'POST',
      url,
    }

    executeKnock(req, lockId, force, deferred.resolve, deferred.reject)
    return deferred.promise
  }

  this.cancelKnock = () => {
    if (activeKnockPromise) {
      activeKnockPromise.reject()
    }
    if (activeKnockTimeout) {
      $timeout.cancel(activeKnockTimeout)
      activeKnockTimeout = null
    }
    if (forceKnockTimeout) {
      $timeout.cancel(forceKnockTimeout)
      forceKnockTimeout = null
    }
  }

  // Force run knock request with force=true parameter to give peer a chance to save it's story
  // If FORCE_TAKEOVER_AFTER_TIMEOUT_MS expires and lock was not relinquished, call force takeover
  this.force = (id, url, subId) => this.knock(id, url, subId, true)

  this.unlock = () => {
    if (!_lastLock) {
      return
    }
    const req = {
      method: 'POST',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/unlock/${_lastLock}`,
    }
    _lastLock = null
    return $http(req)
  }

  this.cleanUp = () => {
    this.cancelLock()
    this.cancelKnock()
    if (_lastLock) {
      this.unlock()
    }
  }
  const cleanUp = this.cleanUp
  
  const unlockAndCleanUp = () => {
    try {
      if (hasLock && _lastLock && !window.ignoreUnlock) {
        navigator.sendBeacon(
          `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/unlock/${_lastLock}`
        )
      }
      _lastLock = null
      hasLock = false
      cleanUp()
    } catch (_) {
      // We can ignore this error since most of the time user is logged out from
      // Okta and /unlock call will probably fail
    }
  }

  // kill the lock if the user leaves the page.
  window.addEventListener('pagehide', unlockAndCleanUp)

  let maxIdleTime = MIN_IDLE_TIMEOUT
  let warningTime = MIN_IDLE_WARNING

  // Fixing race condition with settings load
  $rootScope.$on('ELLIPSIS_STORY_LOADED', () => {
    const lockSettingsDetails =
      (window.org_settings && window.org_settings.locking) || {}
    maxIdleTime = Math.ceil(lockSettingsDetails.maxIdleTime || MIN_IDLE_TIMEOUT)
    warningTime = Math.ceil(lockSettingsDetails.warningTime || MIN_IDLE_WARNING)
    this.updateTimeout()
  })

  let activeTimeout
  let warningTimeout
  this.updateTimeout = () => {
    if (hasLock) {
      const curr = new Date()
      curr.setMinutes(curr.getMinutes() + maxIdleTime)
      activeTimeout = curr
      const warn = new Date()
      warn.setMinutes(warn.getMinutes() + warningTime)
      warningTimeout = warn
    }
  }
  const updateTimeout = this.updateTimeout

  $rootScope.$on('SAVE_SUCCESS', updateTimeout)
  $rootScope.$on('CHANGE_TAB', updateTimeout)
  $rootScope.$on('RIGHT_TAB_CHANGE', updateTimeout)
  // probably need to listen to keypress / click??
}
